<script>
import qs from "qs";
import {email, helpers, required} from "@vuelidate/validators";
import {mapActions} from "pinia";
import {authStore} from "@/store/authStore";
import {baseLoaderStore} from "@/store/baseLoaderStore";
import {useVuelidate} from "@vuelidate/core";
import InputText from "primevue/inputtext";

export default {
  name: "LoginView",
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  components: {
    InputText
  },
  data() {
    return {
      maxCharCount: 60,
      loginEmail: '',
      loginPassword: '',
      loginError: null
    };
  },
  validations () {
    return {
      loginEmail: {
        required: helpers.withMessage('validations.required', required),
        email: helpers.withMessage('validations.email', email)
      },
      loginPassword: {
        required: helpers.withMessage('validations.required', required),
        successful: helpers.withMessage('validations.badCredentials', () => this.loginError === null)
      }
    }
  },
  methods: {
    ...mapActions(authStore, [
      'loginAction',
      'authGetUserData',
      'getManagerProfile',
      'getBankIdProfileData'
    ]),
    ...mapActions(baseLoaderStore, [
      'showBaseLoader',
      'hideBaseLoader'
    ]),
    async login() {
      this.loginError = null;
      const formData = {
        j_username: this.loginEmail,
        j_password: this.loginPassword,
        _acegi_security_remember_me: 'on'
      };
      const isFormCorrect = await this.v$.$validate();
      this.v$.$touch();
      if (isFormCorrect) {
        this.loginAction(qs.stringify(formData)).then(() => {
          this.showBaseLoader();
          this.loginProcessing();

        }).catch((error) => {
          this.loginError = error;
          console.log(error);
        });
      }
    },
    loginProcessing() {
      localStorage.setItem('authorizedUser', "true");
      this.hideBaseLoader();

      this.authGetUserData().then(()=> {
        this.$emit('on-login');
      })

      if (this.userInfo) {
        this.$i18n.locale = this.userInfo.lang;
      } else {
        this.$i18n.locale = 'se';
      }
    },
    forgotPassword() {
      this.$router.push('/forgotpassword');
    }
  }
}
</script>

<template>
  <div class="login-form">
    <div class="form-group">
      <label>{{$t('auth.yourEmail')}}</label>
      <InputText type="text"
                 v-model="loginEmail"
                 :placeholder="$t('auth.eMail')"
                 :class="{'form-control--error': v$.loginEmail.$error}"

      />
      <span v-for="error of v$.loginEmail.$errors" :key="error.$uid"
            class="form-control-error"
      >
          {{ $t(error.$message) }}
        </span>
    </div>
    <div class="form-group">
      <label>{{$t('auth.password')}}</label>
      <InputText type="password"
                 v-model="loginPassword"
                 :placeholder="$t('auth.password')"
                 :class="{'form-control--error': v$.loginPassword.$error}"
                 class="mb-10"
      />
      <span class="forgot-pass-link" @click="forgotPassword()">
        {{$t('auth.forgotYourPassword')}}
      </span>
    </div>
    <div class="form-group">
      <button type="button" class="login-btn" @click="login()">
        {{$t('auth.login')}}
      </button>
      <div class="login-form-info">
        {{$t('auth.dontHaveAccount')}} <a href="/join" class="login-form-link">{{$t('auth.becomeMember')}}</a>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.login-form {
  position: relative;
  z-index: 1;

  .form-group {
    margin-bottom: 15px;
    padding-bottom: 20px;
    position: relative;

    label {
      color: #fff;
    }

    .form-control {
      &--error {
        border-color: #fe8f18;
      }
    }

    .form-control-error {
      position: absolute;
      bottom: 0;
      font-size: 12px;
      font-weight: 600;
      color: #fe8f18;
    }

    .p-inputtext {
      background: #FFFFFF;
    }
  }

  .forgot-pass-link {
    margin-left: auto;
    font-size: 12px;
    font-weight: 600;
    color: #FFFFFF;;
  }

  .login-btn {
    width: 100%;
    height: 40px;
    margin-bottom: 15px;
    padding: 12px 122px;
    border-radius: 6px;
    background-color: #a163cd;
    font-family: "Open Sans", Arial, sans-serif;
    font-size: 15px;
    color: #fff;
  }

  .login-form-info {
    font-size: 14px;
    font-weight: 600;
    color: #FFFFFF;
    text-align: center;
  }

  .login-form-link {
    color: #c096de;
    cursor: pointer;
  }

}
</style>